/** First URL segment for public user profiles (`/u/@handle`). */
export const USER_PROFILE_PATH_SEGMENT = 'u'

/** Pathnames that are separate static/marketing pages — not the main Drippy app shell. */
export const RESERVED_APP_PATH_SEGMENTS = new Set([
	USER_PROFILE_PATH_SEGMENT,
	'profile',
	'onboarding',
	'create-fashion-experiences',
	'brand-experiences',
	'app',
])

export function encodeSpaceSlugForPath(slug: string): string {
	const hyphenated = slug.trim().replace(/\s+/g, '-')
	return encodeURIComponent(hyphenated)
}

export function decodeSpaceSlugFromPathSegment(segment: string): string {
	try {
		return decodeURIComponent(segment.replace(/\+/g, ' '))
	} catch {
		return segment.replace(/\+/g, ' ')
	}
}

/** Extract the space slug from the first path segment, or null if none / reserved. */
export function spaceSlugFromPathname(pathname: string): string | null {
	const normalized = pathname.replace(/\/+$/, '') || '/'
	if (normalized === '/') return null
	const match = normalized.match(/^\/([^/]+)$/)
	if (!match) return null
	const segment = match[1]
	if (!segment) return null
	if (RESERVED_APP_PATH_SEGMENTS.has(segment.toLowerCase())) return null
	// Skip static asset paths (e.g. `/entry.css`), not space slugs like `b.club`.
	if (/\.(css|html?|js|mjs|cjs|map|json|webp|png|jpe?g|gif|svg|ico|woff2?|ttf|eot)$/i.test(segment)) return null
	return decodeSpaceSlugFromPathSegment(segment)
}
